// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__pygzx","selected":"Chip_selected__2VAHL"};